import type {MonthlyTrendsKpisDto} from '@domain/kpis'
import {KpiType} from '@hconnect/common/types'

import type {MonthToDatePlantPerformanceReviewKpisDto} from '../types'

// Some KPIs are provided with a negative sign in the API, but should be displayed as positive in the UI.
const reversedSignKpis: KpiType[] = [KpiType.MaintenanceCosts]

const mapKpiValue = (value: number | undefined, kpiKey: KpiType): number | undefined => {
  if (value === undefined) return value
  return reversedSignKpis.includes(kpiKey) ? -value : value
}

export const mapPerformanceReviewKpisToTableData = (
  data?: MonthToDatePlantPerformanceReviewKpisDto
) => {
  return Object.entries(data?.kpis ?? {}).map(([kpiKey, {actual, planned}]) => ({
    kpiKey: kpiKey as KpiType,
    actual: mapKpiValue(actual, kpiKey as KpiType),
    planned: mapKpiValue(planned, kpiKey as KpiType)
  }))
}

export const getCurrentVsLastYearKpiChartDatasets = (
  data: MonthlyTrendsKpisDto,
  currentYear: number
) => {
  // Initialize arrays for each dataset (index 0 = January, index 11 = December)
  const lastYearActual: (number | null)[] = new Array(12).fill(null)
  const currentYearPlanned: (number | null)[] = new Array(12).fill(null)
  const currentYearActual: (number | null)[] = new Array(12).fill(null)

  data.kpis.forEach((item) => {
    const monthIndex = item.yearMonth.month - 1
    if (item.yearMonth.year === currentYear - 1) {
      // Last year actual values for line chart
      lastYearActual[monthIndex] = mapKpiValue(item.value.actual, data.kpiType) ?? null
    }
    if (item.yearMonth.year === currentYear) {
      // Current year planned and actual values for bar charts
      currentYearPlanned[monthIndex] = mapKpiValue(item.value.planned, data.kpiType) ?? null
      currentYearActual[monthIndex] = mapKpiValue(item.value.actual, data.kpiType) ?? null
    }
  })

  return {
    lastYearActual,
    currentYearPlanned,
    currentYearActual
  }
}
